import { isMemberAiSubTab, type MemberAiSubTab } from './memberAppRouting'

const SCOPED_PREFIX = 'tl:persist:v1:'
const MEMBER_AI_SUB_KEY = 'member.aiSub'

const LEGACY_CONTROLS_SUB_KEY = 'member.controlsSub'

const parseStoredValue = (raw: string): unknown => {
  try {
    return JSON.parse(raw)
  } catch {
    return raw
  }
}

const serializeReplacement = (raw: string, replacement: MemberAiSubTab): string =>
  raw.trim().startsWith('"') ? JSON.stringify(replacement) : replacement

export const normalizeMemberAiSubValue = (value: unknown): MemberAiSubTab => {
  if (value === 'AI') return 'MAGIC'
  if (value === 'AGENT') return 'CREATE'
  return isMemberAiSubTab(value) ? value : 'CREATE'
}

export const migrateMemberAiSubStorage = (): MemberAiSubTab => {
  if (typeof window === 'undefined') return 'CREATE'
  let resolved: MemberAiSubTab = 'CREATE'

  const migrateStore = (store: Storage, key: string, scoped: boolean) => {
    const raw = store.getItem(key)
    if (raw == null) return
    const parsed = parseStoredValue(raw)
    const next = normalizeMemberAiSubValue(parsed)
    if (isMemberAiSubTab(parsed)) {
      resolved = parsed
    } else if (parsed === 'AGENT' || parsed === 'AI') {
      resolved = next
      store.setItem(key, scoped ? JSON.stringify(next) : serializeReplacement(raw, next))
    }
  }

  try {
    const scopedKeys: string[] = []
    for (let index = 0; index < window.sessionStorage.length; index += 1) {
      const key = window.sessionStorage.key(index)
      if (key?.startsWith(SCOPED_PREFIX) && key.endsWith(`:${MEMBER_AI_SUB_KEY}`)) scopedKeys.push(key)
    }
    scopedKeys.forEach((key) => migrateStore(window.sessionStorage, key, true))
    migrateStore(window.sessionStorage, MEMBER_AI_SUB_KEY, false)

    // Also migrate legacy member.controlsSub = 'AI' -> member.aiSub = 'MAGIC'
    const legacyControls = parseStoredValue(window.sessionStorage.getItem(LEGACY_CONTROLS_SUB_KEY) ?? '')
    if (legacyControls === 'AI') {
      resolved = 'MAGIC'
      window.sessionStorage.setItem(MEMBER_AI_SUB_KEY, 'MAGIC')
    }
  } catch {
    // Best-effort migration; the state hook falls back to Create.
  }

  try {
    migrateStore(window.localStorage, MEMBER_AI_SUB_KEY, false)
    const legacyControls = parseStoredValue(window.localStorage.getItem(LEGACY_CONTROLS_SUB_KEY) ?? '')
    if (legacyControls === 'AI') {
      resolved = 'MAGIC'
      window.localStorage.setItem(MEMBER_AI_SUB_KEY, 'MAGIC')
    }
  } catch {
    // Stale legacy keys can be ignored.
  }

  return resolved
}
